<template>
    <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
    >
        <template #button-content>
            <div class="d-sm-flex d-none user-nav">
                <p class="user-name font-weight-bolder mb-0">
                    {{ authUserInfo.email }}
                </p>
                <span class="user-status">
                    {{ authUserInfo.userName }}
                </span>
            </div>
            <b-avatar
                size="40"
                variant="light-primary"
            />
        </template>

        <b-dropdown-item
            link-class="d-flex align-items-center"
            @click="logout"
        >
            <feather-icon
                size="16"
                icon="LogOutIcon"
                class="mr-50"
            />
            <span>
                Logout
            </span>
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-header>
            Available Services
        </b-dropdown-header>
        <b-dropdown-item
            link-class="d-flex align-items-center"
            v-for="(serviceGroup, index) in serviceGroups"
            :key="index"
            @click="moveService(serviceGroup)"
        >
            <span style="text-overflow:ellipsis;overflow:hidden">
                {{ serviceGroup.name.toUpperCase() }}
            </span>
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import { auth } from '@/auth/hyper-auth'
import { getCurrentInstance, computed } from '@vue/composition-api'
export default {
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const router = vm.$router
        const authUserInfo = computed(() => store.getters.authUserInfo)
        const userInfo = computed(() => store.getters.userInfo)
        const serviceGroups = computed(() => store.getters.authServiceGroups)

        const goToAuthCenter = () => {
            const token = localStorage.getItem(auth.authConfig.storageTokenKeyName)
            window.location.href = `${process.env.VUE_APP_AUTH_CENTER_URL}/signin/email/${authUserInfo.value.email}/token/${token}`
        }
        const logout = () => {
            localStorage.removeItem(auth.authConfig.storageTokenKeyName)
            router.push({ name: 'auth-login' })
        }
        const moveService = (serviceGroup) => {
            /* const token = localStorage.getItem('x-auth-token')
            vm.$router.push(`${serviceGroup.domain}/signin/email/${authUserInfo.value.email}/token/${token}`) */
            const token = localStorage.getItem(auth.authConfig.storageTokenKeyName)
            window.open(`${serviceGroup.domain}/signin/email/${authUserInfo.value.email}/token/${token}`)
        }
        return {
            authUserInfo,
            serviceGroups,
            userInfo,
            goToAuthCenter,
            logout,
            moveService
        }
    }
}
</script>

<style>

</style>
